import React, { ReactNode, useContext, useEffect, useState } from 'react';

import RemoteAccessTotalsContext from '@totem/components/services/remoteAccess/totals/RemoteAccessTotalsContext';
import {
  RemoteAccessTotals,
  RemoteAccessTotalsInput,
} from '@totem/components/services/remoteAccess/totals/types';
import { buildParameters } from '@totem/components/services/remoteAccess/totals/utilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { REMOTE_ACCESS_ENDPOINT } from '@totem/utilities/endpoints';
import { omitNilOrEmpty } from '@totem/utilities/objectUtilities';
type Props = {
  regionId?: string[];
  buildingId?: string[];
  controlSystemId?: string[];
  children?: ReactNode;
};
const RemoteAccessTotalsContainer = ({
  regionId,
  buildingId,
  controlSystemId,
  children,
}: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [input, updateInput] = useState<RemoteAccessTotalsInput>({
    regionId,
    buildingId,
    controlSystemId,
  });
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<RemoteAccessTotals>(null);
  const [action, setAction] = useState<string>('');
  const setInput = (updated: Partial<RemoteAccessTotalsInput>) => {
    updateInput(omitNilOrEmpty({ ...input, ...updated }));

    setRefreshData(true);
  };
  useEffect(() => {
    setRefreshData(true);
  }, [regionId, buildingId, controlSystemId, userProfile.organization.id]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);
      const uri = `${REMOTE_ACCESS_ENDPOINT}/totals`;
      const payload = buildParameters(regionId, buildingId, controlSystemId);
      fetch(uri, {
        method: 'POST',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result: RemoteAccessTotals) => {
          if (isNotNull(result) && isNotNull(result.total)) {
            setData(result);
          }
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, getApiToken]);
  const handleAction = (newAction: string) => {
    switch (newAction) {
      case 'refresh':
        setRefreshData(true);

        setAction('');
        break;
      default:
        setAction(newAction);
    }
  };
  return (
    <RemoteAccessTotalsContext.Provider
      value={{
        input,
        setInput,
        loading: isLoading,
        data,
        action,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </RemoteAccessTotalsContext.Provider>
  );
};
export default RemoteAccessTotalsContainer;
